module.exports = __webpack_public_path__ + "static/media/1_06.e46b0547.jpg";